const companyInfo = {
  phoneNumber: '+385 91 525 6511',
  email: 'ured@izvrsnost.hr',
  pin: '99870145004',
  address: 'Vodnikova 5, 10000 Zagreb',
  bankName: 'Privredna banka Zagreb d.d.',
  iban: 'HR4023400091111224816',
  swift: 'PBZGHR2X',
  facebookUrl: 'https://web.facebook.com/InkubatorIzvrsnosti',
  instagramUrl: 'https://www.instagram.com/inkubator_izvrsnosti',
  youtubeUrl: 'https://www.youtube.com/channel/UC64_8r3W3OdXW032pjvROrg',
  linkedinUrl: 'https://www.linkedin.com/company/inkubator-izvrsnosti',
  whatsappUrl: '#',
};

export { companyInfo };
